module.exports = __webpack_public_path__ + "img/topic-cover.edcd9853.jpg";